import { Progress as AntProgress } from 'antd';
import styled, { css } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

const lineProgress = css`
  display: inline-flex;
  align-items: center;
  line-height: 24px;

  &.ant-progress-status-success {
    .anticon path {
      fill: ${colors.green600};
    }

    .ant-progress-bg {
      background-color: ${colors.green600};
    }
  }

  &.ant-progress-status-exception {
    .anticon path {
      &:first-child {
        fill: ${colors.red600};
        opacity: 1;
      }
      &:last-child {
        fill: ${colors.gray0};
      }
    }

    .ant-progress-bg {
      background-color: ${colors.red600};
    }
  }

  .ant-progress {
    &-inner {
      vertical-align: unset;
    }

    &-bg {
      background-color: ${colors.blue600};
    }

    &-text {
      display: flex;
      line-height: inherit;
      color: ${colors.gray900};

      .anticon {
        font-size: 20px;
      }

      svg {
        width: 1em;
        height: 1em;
      }
    }
  }
`;

const circleProgress = css`
  .ant-progress {
    &-inner {
      background-color: ${colors.gray0};

      &:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
        stroke: ${colors.blue600};
      }
    }
  }
`;

export const Progress = styled(AntProgress)`
  &.ant-progress-line {
    ${lineProgress}
  }

  &.ant-progress-circle {
    ${circleProgress}
  }
`;
